/**
 * Appends a parameter to a URL.
 * @param {string} url - The URL to append the parameter to.
 * @param {string} name - The name of the parameter.
 * @param {string} value - The value of the parameter.
 * @returns {string} The URL with the parameter appended.
 */
function appendParamToUrl(url, name, value) {
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return (url + separator + encodeURIComponent(name) + '=' + encodeURIComponent(value));
}

module.exports = {
    appendParamToUrl: appendParamToUrl,
};
